var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-base',_vm._g({attrs:{"value":_vm.value,"filter":_vm.filter,"hide-delete":_vm.hideDelete,"readonly":_vm.readonly,"hide-offset":_vm.hideOffset,"api-method":_vm.apiMethod,"fields":_vm.fields,"form-title":_vm.formTitle,"is-hover":_vm.isHover}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }